/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 09/04/2018.
*
* users-edit-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Editar sucursal"
    modal-title="Editar sucursal"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave">
    <div class="content">
      <branches-form
        ref="form"
        :old-model="model"
      />
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import BranchesForm from '@/modules/branches/branches-form'
import store from '@/store'

export default {
  name: 'BranchesEditView',
  components: {FormModal, BranchesForm},
  computed: {
    model () {
      return this.$store.getters['branches/item']
    }
  },
  methods: {
    onCloseModal () {
      this.$router.push({name: 'branches'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('branches/get', {id: to.params.id})
      .then(response => {
        return store.dispatch('dealers/query', {
          'filters[where][id][eq]': response.data.dealerId
        }).then(next)
      }).catch(next)
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .content {
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/branches/branches-edit-view.vue